import { FiltrosSolicitudes } from './../../models/FiltrosSolicitudes';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AccesoService } from '../acceso/acceso.service';
import { environment } from '../../../environments/environment';
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class SolicitudService {
  readonly urlBase = environment.rutaBase;
  header: HttpHeaders;
  datos: any;

  constructor(
    private http: HttpClient,
    private accesoService: AccesoService
  ) {
    this.header = this.accesoService.desencriptarTOKEN();
  }

  guardarSolicitud(body: any) {
    let headers = this.accesoService.desencriptarTOKEN(); 
    return this.http
      .post(`${this.urlBase}/solicitud?id_Empresa=1`,body,{headers})
      .pipe(
        map((data) => {
          return data;
        })
      );

    // console.log('dataSolicitudService',body)
    // let headers: HttpHeaders = new HttpHeaders();
    // headers =  headers.append('Content-Type', 'application/json');
    // headers =  headers.append('Authorization', 'E76919sdfh46531reg9df637h');
    // return this.http.post(`http://localhost:2528/api-solicitudDB/CrearSolicitud?id_Empresa=1`,body,{headers})
  }

  obtenerEstadoSolicitud(Filtro: FiltrosSolicitudes) {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.get(
      `${this.urlBase}/solicitud?id_Empresa=1&TipoDocumentoIdentidad=${Filtro.TipoDocumentoIdentidad}&NroDocumentoIdentidad=${Filtro.NroDocumentoIdentidad}&Codigo=${Filtro.Codigo}`, { headers }
    )
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
    // let headers: HttpHeaders = new HttpHeaders();
    // headers =  headers.append('Content-Type', 'application/json');
    // headers =  headers.append('Authorization', 'E76919sdfh46531reg9df637h');
    // return this.http.get(`http://localhost:2528/api-solicitudDB/ObtenerSolicitud?id_Empresa=1&TipoDocumentoIdentidad=${Filtro.TipoDocumentoIdentidad}&NroDocumentoIdentidad=${Filtro.NroDocumentoIdentidad}&Codigo=${Filtro.Codigo}`,{headers})

  }

  ObtenerListadoRespuestas() {
    let headers = this.accesoService.desencriptarTOKEN();
    return this.http.get(
      `${this.urlBase}/respuesta?id_Empresa=1`, { headers }
    )
      .pipe(
        map((data) => {
          this.datos = data;
          return data;
        })
      );
    // let headers: HttpHeaders = new HttpHeaders();
    // headers =  headers.append('Content-Type', 'application/json');
    // headers =  headers.append('Authorization', 'E76919sdfh46531reg9df637h');
    // return  this.http.get(`http://localhost:2528/api-solicitudDB/ObtenerRespuesta?id_Empresa=1`,{headers});
  }
}
